export const PageText = {
  _1: 'Help & Guides',
  _2: 'Something not clear? Check our help section...'
};

export const Boxes = [
  {
    title: 'Get started',
    targetId: 'get-started'
  },
  {
    title: 'Importance of air quality (monitoring)',
    targetId: 'importance-of-air-quality'
  },
  {
    title: 'How we help interpret air quality?',
    targetId: 'how-we-help-interpreting-air-quality'
  },
  {
    title: 'How good is aircheckr?',
    targetId: 'how-good-is-aircheckr'
  },
  {
    title: 'aircheckr legal',
    targetId: 'aircheckr-legal'
  }
];

export const Categories = {
  _1: {
    title: 'Get started',
    idSelector: '#get-started',
    subcategories: [
      {
        key: 0,
        text: 'Here you will find all info and guides you need to get started with aircheckr:'
      }
    ],
    links: [
      {
        text: 'How to get an aircheckr access token/key?',
        linkAddress: '/help-and-guides/how-to-get-an-aircheckr-access-token'
      },
      {
        text: 'First steps with the aircheckr API and widget',
        linkAddress: '/help-and-guides/first-steps-with-the-aircheckr-api'
      },
      {
        text: 'API developer documentation',
        externalLinkAddress: 'https://www.aircheckr.com/api_docs'
      },
      {
        text: 'aircheckr newsletter',
        linkAddress: '/help-and-guides/airchecker-newsletter'
      },
      {
        text: 'Get in touch',
        linkAddress: '/contact'
      }
    ]
  },
  _2: {
    title: 'Importance of air quality (monitoring)',
    idSelector: '#importance-of-air-quality',
    subcategories: [
      {
        key: 0,
        text: 'This is a great starting point to learn more about air quality and its effects:'
      }
    ],
    links: [
      {
        text: 'What is air pollution?',
        linkAddress: '/help-and-guides/what-is-air-pollution'
      },
      {
        text: 'The silent killer',
        linkAddress: '/help-and-guides/the-silent-killer'
      },
      {
        text: 'Air pollution & the curse of the 3C’s',
        linkAddress: '/help-and-guides/air-pollution-and-the-curse'
      },
      {
        text: 'Does air quality vary a lot?',
        linkAddress: '/help-and-guides/is-air-quality-varying-a-lot'
      },
      {
        text: 'Do my customers really want air quality info? ',
        linkAddress: '/help-and-guides/do-my-customers-really-want-air-quality-info'
      },
      {
        text: 'There is hope!',
        linkAddress: '/help-and-guides/there-is-hope'
      }
    ]
  },
  _3: {
    title: 'How we help interpret air quality?',
    idSelector: '#how-we-help-interpreting-air-quality',
    subcategories: [
      {
        key: 0,
        text: 'Air pollution is complex. Read here how aircheckr helps make air quality information easy to use:'
      }
    ],
    links: [
      {
        text: 'aircheckr Air Quality Index',
        linkAddress: '/help-and-guides/air-quality-index'
      },
      {
        text: 'Why health-based?',
        linkAddress: '/help-and-guides/why-health-based'
      },
      {
        text: 'Personalised recommendations (& alerts)',
        linkAddress: '/help-and-guides/personalised-recommendations'
      },
      {
        text: 'What is the difference between the “aircheckr AQI” & “aircheckr AQ comparison”?',
        linkAddress: '/help-and-guides/difference-between-aqi-and-aq-comparison'
      },
      {
        text: 'What air quality information can I get out of aircheckr?',
        linkAddress: '/help-and-guides/what-air-quality-info-can-i-get'
      },
      {
        text: 'What about long term effect of air pollution?',
        linkAddress: '/help-and-guides/what-with-long-term-effect'
      }
    ]
  },
  _4: {
    title: 'How good is aircheckr?',
    idSelector: '#how-good-is-aircheckr',
    subcategories: [
      {
        key: 0,
        text: 'Let us show you that aircheckr reaches a high quality:'
      }
    ],
    links: [
      {
        text: 'The best available AQ information',
        linkAddress: '/help-and-guides/the-best-available-aq-info'
      },
      {
        text: 'Highly validated',
        linkAddress: '/help-and-guides/highly-validated'
      },
      {
        text: 'Status',
        linkAddress: '/help-and-guides/status'
      }
    ]
  },
  _5: {
    title: 'aircheckr legal',
    idSelector: '#aircheckr-legal',
    subcategories: [
      {
        key: 0,
        text: 'All legal documents related to our services and website can be found here:'
      }
    ],
    links: [
      {
        text: 'Terms of Use',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/terms-of-use/',
        target: '_blank'
      },
      {
        text: 'Cookie policy',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/cookie-policy/',
        target: '_blank'
      },
      {
        text: 'Privacy policy',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/privacy-policy/',
        target: '_blank'
      },
      {
        text: 'Saas Agreement Free Plan',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/nazka-aircheckr-SaaS-free-plan_17042018_web.pdf',
        target: '_blank'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/helpandguides_page.js